import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { Close, Plus } from '@element-plus/icons-vue';
import { storeToRefs } from 'pinia';
import { useMultiWhitelabelListStore } from '@/store/multi-whitelabel-slug-list/multi-whitelabel-slug-list.store';
import { DictionaryWlListItem } from '@/models/whitelabel-list/whitelabel-list.model';
import { showSuccessNotification } from '@/utils/show-notification.util';

const icons = {
  Plus,
};

export default defineComponent({
  name: 'MultiWhitelabel',
  components: {
    MultiWhitelabelDialog: defineAsyncComponent(() =>
      import('@/components/multi-whitelabel-dialog/multi-whitelabel-dialog')),
    Close,
  },
  emits: ['changeWhitelabelList'],
  setup(props, { emit }) {
    const isMultiWhitelabelDialogVisible = ref<boolean>(false);
    const selectedWhitelabelSlugList = ref<DictionaryWlListItem[]>([]);

    const getCdnUrl = (fileName: string): string => {
      return `https://cdn.igrand.pro/backoffice/logo/${fileName}.svg`;
    };

    const multiWhitelabelListStore = useMultiWhitelabelListStore();
    const { multiWhitelabelSlugList, multiWhitelabelList } = storeToRefs(multiWhitelabelListStore);
    const { setMultiWhitelabelList } = multiWhitelabelListStore;

    const openDialog = (): void => {
      selectedWhitelabelSlugList.value = multiWhitelabelList.value;
      isMultiWhitelabelDialogVisible.value = true;
    };

    const deleteWhitelabel = (currentSlug: string): void => {
      const filteredMultiWhitelabelList = multiWhitelabelList.value
        .filter(({ slug }: DictionaryWlListItem) => slug !== currentSlug);

      setMultiWhitelabelList(filteredMultiWhitelabelList);
      selectedWhitelabelSlugList.value = multiWhitelabelList.value;
      emit('changeWhitelabelList');

      showSuccessNotification(`${currentSlug} removed`);
    };

    const addWhitelabel = (multiWhitelabelList: DictionaryWlListItem[]): void => {
      setMultiWhitelabelList(multiWhitelabelList);
      selectedWhitelabelSlugList.value = multiWhitelabelList;
      emit('changeWhitelabelList');
    };

    return {
      icons,
      isMultiWhitelabelDialogVisible,
      openDialog,
      multiWhitelabelSlugList,
      getCdnUrl,
      deleteWhitelabel,
      multiWhitelabelList,
      selectedWhitelabelSlugList,
      addWhitelabel,
    };
  },
});
